import { put, select, takeLatest } from 'redux-saga/effects';
import requestWrapper from 'utils/requestWrapper';
import history from 'utils/history';
import { LOAD_ABSENCES, CHANGE_ABSENCES, CHANGE_ABSENCE, DELETE_ABSENCE } from './constants';

import {
  // list
  loadAbsencesError,
  loadAbsencesSuccess,
  changeAbsencesSuccess,
  changeAbsencesError,
  // one
  changeAbsenceError,
  changeAbsenceSuccess,
  deleteAbsenceSuccess,
  deleteAbsenceError,
} from './actions';

import { notification } from 'antd';


export function* loadAbsences() {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));

    // we get the campaigns linked to the absences
    const itemsList = yield requestWrapper('GET', `absence/list`, '', currentUser.token);
    
    if (!itemsList && !itemsList?.data) {
      yield put(loadAbsencesSuccess(false));
    } else {
      const firstElem = itemsList.data[0];
      yield put(loadAbsencesSuccess(itemsList, firstElem));
    }
  } catch (error) {
    yield put(loadAbsencesError(error));
  }
}

export function* changeAbsences(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));
    const { list } = action;

    let updatedList = false;

    updatedList = yield requestWrapper('PATCH', 'absence/status', list, currentUser.token);
    notification.success({ message: 'Mis à jour' });

    if (!updatedList) {
      yield put(changeAbsencesSuccess(false));
    } else {
      yield put(changeAbsencesSuccess(updatedList));
    }
  } catch (error) {
    yield put(changeAbsencesError(error));
  }
}

export function* changeAbsence(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));
    const { absenceData } = action;

    let changedAbsence = false,
      isNew = !absenceData?._id;

    if (isNew) {
      changedAbsence = yield requestWrapper(
        'POST',
        'absence/new/',
        absenceData,
        currentUser.token
      );
      notification.success({ message: 'Établi' });
    } else {
      changedAbsence = yield requestWrapper('PATCH', 'absence/', absenceData, currentUser.token);
      notification.success({ message: 'Mis à jour' });
    }

    if (!changedAbsence) {
      yield put(changeAbsenceSuccess(false));
    } else {
      // if new we update the url, item props will be updated
      if (isNew) {
        history.push({ pathname: `/absences/${updatedStydent._id}` });
      }
      yield put(changeAbsenceSuccess(changedAbsence));
    }
  } catch (error) {
    yield put(changeAbsenceError(error));
  }
}

export function* deleteAbsence(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));
    const { id } = action;

    const deleteAbsence = yield requestWrapper(
      'PATCH',
      `absence/remove`,
      {
        _id: id,
        active: false,
      },
      currentUser.token,
    );

    if (deleteAbsence) {
      yield put(deleteAbsenceSuccess());
    }
  } catch (error) {
    yield put(deleteAbsenceError(error));
  }
}

export default function* absenceSaga() {
  // list
  yield takeLatest(LOAD_ABSENCES, loadAbsences);
  yield takeLatest(CHANGE_ABSENCES, changeAbsences);
  // one
  yield takeLatest(CHANGE_ABSENCE, changeAbsence);
  yield takeLatest(DELETE_ABSENCE, deleteAbsence);
}
